<template>
  <div>
    <nav-menu :navMenuList="navMenuList"
    :activeIndex="activeIndex"
    @handleSelect="handleSelect"></nav-menu>
    <router-view></router-view>
  </div>
</template>
<script>
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'nav-menu': NavMenu
  },
  data () {
    return {
      navMenuList: [{
        text: '账号设置',
        pathName: 'SettingsUser'
      }],
      activeIndex: '0'
    }
  },
  methods: {
    handleSelect (key) {
      this.activeIndex = key
      // console.log(this.navMenuList[key].text)
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Personal/Settings/settings.vue


// WEBPACK FOOTER //
// src/components/Personal/Settings/settings.vue